import { useAppSelector } from '../../../core/utils';
import { selectCurrentModelVehiclesByTransmissionAndColor } from '../../../core/reducers/vehicleListFilters';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { InventoryAvailabilityStatus } from '../../../core/apis/inventoryApi';
import useFetchInventoryStatus from '../../../core/apiHooks/useFetchInventoryStatus';
import { getVehiclesByInventoryStatus } from '../../TrimCardGrid/utils/getVehiclesByInventoryStatus';
import useNoInventoryData from './useNoInventoryData';
import { getInventoryTrimFilterOptions } from '../service/utils';
const useInventoryData = () => {
    const { allTrims, allModelYears, allInventoryStatuses } = useNoInventoryData();
    const { isLoading: isInventoryStatusLoading, isFetching: isInventoryStatusFetching, isUninitialized, } = useFetchInventoryStatus(allTrims.length > 0, { shouldResetStatus: true });
    const vehicles = useAppSelector(selectCurrentModelVehiclesByTransmissionAndColor);
    const inStockVehicles = getVehiclesByInventoryStatus(vehicles, InventoryAvailabilityStatus.inStock);
    const onItsWayVehicles = getVehiclesByInventoryStatus(vehicles, InventoryAvailabilityStatus.onItsWay);
    const { modelYear: currentModelYear } = useAppSelector(selectCurrentVehicle);
    const allInventory = [...inStockVehicles, ...onItsWayVehicles];
    const trims = getInventoryTrimFilterOptions(allInventory);
    // current selected model year will always be present
    const modelYears = [...new Set([...allInventory.map(v => v.modelYear), currentModelYear])];
    const inventoryStatuses = [
        inStockVehicles.length > 0 ? InventoryAvailabilityStatus.inStock : undefined,
        onItsWayVehicles.length > 0 ? InventoryAvailabilityStatus.onItsWay : undefined,
    ].filter(status => !!status);
    if (isInventoryStatusLoading || isInventoryStatusFetching || isUninitialized) {
        return { trims: [], modelYears: [], inventoryStatuses: [], hasInventory: false };
    }
    if (trims.length === 0)
        return { trims: allTrims, modelYears: allModelYears, inventoryStatuses: allInventoryStatuses, hasInventory: false };
    return { trims, modelYears, inventoryStatuses, hasInventory: true };
};
export default useInventoryData;
